module.exports = __webpack_public_path__ + "img/collection-engagementRingsFastDelivery.9da6871.webp";